// An Audiense account id is a 24-hex ObjectId. Anything else (empty, "undefined", a mistyped id) is no account.
// Hex is case-insensitive and the admin field is free text, so an id typed in capitals is still the account: it is
// sent lower-case, the way every other product and Salesforce hold it.
const ACCOUNT_ID = /^[0-9a-f]{24}$/i;

// ChurnZero's names for the account and the contact (the identity), as the platform stamps them.
export const CHURNZERO_ACCOUNT_PROPERTY = 'AccountExternalID';
export const CHURNZERO_CONTACT_PROPERTY = 'ContactExternalID';

export function audienseAccountId(value: unknown): string | undefined {
  return typeof value === 'string' && ACCOUNT_ID.test(value) ? value.toLowerCase() : undefined;
}

/**
 * Stamps the account (`account_id` and `AccountExternalID`) and the contact (`ContactExternalID`) every event
 * carries. With no account only the contact is stamped, and no empty or "undefined" account is ever sent.
 */
export function stampAccountAndContact(
  properties: { [propertyName: string]: any },
  accountId: string | undefined,
  contactId: string | null | undefined
): void {
  if (accountId) {
    properties.account_id = accountId;
    properties[CHURNZERO_ACCOUNT_PROPERTY] = accountId;
  } else {
    delete properties.account_id;
    delete properties[CHURNZERO_ACCOUNT_PROPERTY];
  }

  if (contactId) {
    properties[CHURNZERO_CONTACT_PROPERTY] = contactId;
  }
}
